module.exports = __webpack_public_path__ + "fonts/NunitoSans-ExtraBold.d542495.woff";